import React from "react";
//#region types
import { SupplierDefaultPeriodisationFieldProps } from "models/propTypes/supplierPropTypes";
import { InvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import RecurringPeriodisation from "components/invoice/forms/_fields/recurringPeriodisation";
import { getIn, useFormikContext } from "formik";
//#endregion

const SupplierDefaultPeriodisationField: React.FC<SupplierDefaultPeriodisationFieldProps> = (props) => {
  const { name = "", value, onChange, onBlur, isReadOnly } = props;
  const { errors, touched } = useFormikContext<Record<string, unknown>>();
  const fieldError = getIn(errors, name);
  const fieldTouched = getIn(touched, name);
  // GenericForm's memoized field container passes a new value one render late. Rendered with that stale value, the
  // number inputs snap back and report it again, overwriting what was typed, so the latest input is kept here.
  const [currentValue, setCurrentValue] = React.useState(value);
  React.useEffect(() => setCurrentValue(value), [value]);

  const updateValue = (updated: InvoiceFormTypes.RecurringPeriodisation) => {
    setCurrentValue(updated);
    onChange?.(updated);
  };

  return (
    <RecurringPeriodisation
      name={name}
      value={currentValue ?? {}}
      setValue={updateValue}
      onInputFocus={() => {
        if (!currentValue?.isEnabled) updateValue({ ...currentValue, isEnabled: true });
      }}
      setTouched={() => {}}
      onChange={() => {}}
      onBlur={() => onBlur?.()}
      error={fieldError}
      // The generic blur handler marks the whole field touched with a boolean; the inner inputs read touched per key.
      touched={fieldTouched === true ? { from: true, duration: true } : fieldTouched}
      hasError={!!fieldError && !!fieldTouched}
      disabled={isReadOnly}
      isPeriodisationAdvancedConfiguration={false}
      stacked
    />
  );
};

export default SupplierDefaultPeriodisationField;
